<!-- Main Page Start -->
<div class="content-wrapper chatWrapper">
    <section class="chatSection">
        <div class="chat-body height100">
            <div class="row height100">
                <div class="col-lg-4 pr-0 height100 leftPenal"
                    [ngClass]="addResponsiveClass==='1'? 'hideListonMobile':''">
                    <div class="bg-white borderrt" style="height: 100%;">
                        <div class="chat_heading">
                            <h6 class="heading-6 m-0"><a href="javascript:void(0);" routerLink="/message"><img src="assets/images/arrow_back.svg" class="ht"></a> <span>Messages</span></h6>
                        </div>
                        <div class="searchSec">
                            <div class="input-group-icon input-group-icon-left ">
                                <div class="col-list-right">
                                    <span class="input-icon input-icon-right font-16"><img
                                            src="assets/images/search.svg"></span>
                                    <input class="form-control form-control-rounded form-control-solid" id="key-search"
                                        type="text" placeholder="Search chat by candidate name and job ID"
                                        [(ngModel)]="chatListSearchBy">
                                </div>
                            </div>
                            <div class="dropdown" ngbDropdown>
                                <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                    <img src="assets/images/filter.svg" alt="filter"></a>
                                <ul class="dropdown-menu dropdown-menu-right" ngbDropdownMenu
                                    aria-labelledby="dropdown_profile_area">
                                    <li [ngClass]="{'activeFilter' : chatListFilterBy == 'all'}">
                                        <a (click)="onFilterChatList('all')" class="dropdown-item"
                                            href="javascript:void(0);">All
                                            Chats</a>
                                    </li>
                                    <li [ngClass]="{'activeFilter' : chatListFilterBy == 'unread'}">
                                        <a (click)="onFilterChatList('unread')" class="dropdown-item"
                                            href="javascript:void(0);">Unread
                                            Chats</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="paddingside p-0" style="height: calc(100% - 135px);">
                            <div class="scrollbar infinite-scroll">
                                <!-- Messages -->
                                <ul class="friend-list-heding">
                                    <li class="position" *ngFor="let data of dialogListing; let i = index">
                                        <div class="nav-label id">
                                            <strong>Job ID:JOB{{data?.job_id?.substr((data?.job_id).length -
                                                7)}}</strong>
                                            <!-- <p>Job Title: {{data.job_name}}</p>  -->
                                            <p>{{data?.last_message_time | date:'dd/MM/yyyy HH:mm a'}}</p>
                                        </div>
                                    </li>
                                    <li *ngIf="dialogListing == 0">
                                        <div class="noDataFound">
                                            <h3>No Messages</h3>
                                        </div>
                                    </li>
                                </ul>
                                <ul class="friend-list">
                                    <li class="bounceInDown"
                                        *ngFor="let dialog of dialogListing | recruiterChatFilter: chatListSearchBy : chatListFilterBy : userId; let i = index;"
                                        (click)="selectedUser(i,dialog)"
                                        [ngClass]="chat_dialog_id ===  dialog?.chat_dialog_id ? 'selected' : ''">
                                        <a href="javascript:void(0);"
                                            (click)="getChatHistory(dialog?.chat_dialog_id,dialog?.job_id,dialog?.user_id,dialog?.name[dialog.user_id],dialog);"
                                            class="clearfix">
                                            <!--left -->
                                            <div class="leftSideUsers">
                                                <div class="chatUserImage">
                                                    <img src="{{((dialog?.user_pic == '' || dialog?.user_pic == null || dialog?.user_pic ==undefined) ? '../../../assets/images/profile-img.jpg' : (baseUrl+ dialog?.user_pic))}}"
                                                        alt="user" class="img-circle">
                                                </div>
                                                <div class="chatHeading">
                                                    <div class="friend-name">
                                                        <strong>{{dialog?.name[dialog.user_id]}} </strong>
                                                        <p>{{dialog?.company_name}}</p>
                                                    </div>
                                                    <div class="highlite" hidden>{{dialog?.job_name}}</div>
                                                    <div class="last-message text-muted">
                                                        <strong>
                                                            {{dialog?.last_message[dialog?.job_id]}}
                                                        </strong>
                                                    </div>
                                                    <small class="time text-muted">{{dialog?.last_message_time ? (dialog?.last_message_time |
                                                        dateAgoConvert):'' }}<br></small>                                                        
                                                    <small class="unreadCount"
                                                        *ngIf="dialog?.unread_count[dialog?.job_id] && dialog?.unread_count[dialog?.job_id]>0"
                                                        class="chat-alert label label-danger">{{dialog?.unread_count[dialog?.job_id]}}</small>

                                                </div>
                                            </div>
                                            <!-- left -->
                                        </a>
                                    </li>
                                </ul>
                                <!-- End -->
                            </div>
                        </div>
                    </div>

                </div>
                <!--  -->
                <div [ngClass]="addResponsiveClass==='1'? 'showOnMobile':''"
                    class="col-lg-8 pl-0 height100 mobChatScreen">
                    <div class="bgwhite height100" *ngIf="chat_dialog_id !==''">
                        <div class="action-header chat">

                            <div class="chattop">
                                <a (click)="backToList()" class="backBtn"><img src="assets/images/arrow_back.svg"
                                        class="ht"></a>
                                <div class="friend-name">
                                    <figure><img
                                            [src]="(chatDialog.user_pic != '' && chatDialog.user_pic != null && chatDialog.user_pic !== 'undefined') ? baseUrl+chatDialog.user_pic : '../../../assets/images/profile-img.jpg' "
                                            alt="Chat" class="img-circle"></figure>
                                    <strong>{{user_name}}</strong>
                                </div>
                            </div>

                            <div class="dropdown open innelist1" ngbDropdown #myDrop1="ngbDropdown"> <a
                                    href="javascript:void(0);" data-toggle="dropdown" ngbDropdownToggle role="button"
                                    aria-haspopup="true" aria-expanded="false" id="dropdown_profile_area"><img
                                        src="assets/images/ic_option.svg"></a>
                                <div class="dropdown-menu ml-3 dropdown-menu-right dropdown-menu-animated profile-dropdown  dropdown-arrow "
                                    ngbDropdownMenu aria-labelledby="dropdown_profile_area">
                                    <ul>
                                        <li> <a href="javascript:void(0);"
                                                (click)="clearChat(chat_dialog_id,job_id,user_id, user_name );myDrop1.close();">Clear
                                                Chat</a></li>
                                        <li> <a href="javascript:void(0);"
                                                (click)="chatModal(block);myDrop1.close();">{{checkBlockStatus ?
                                                'Unblock':'Block'}}</a>
                                        </li>
                                        <li> <a href="javascript:void(0);"
                                                (click)="chatModal(Delete);myDrop1.close();">Delete Chat</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="mesgs">
                            <div class="msg_history scrollbar2" id="style-1" #messagesListContainer>
                                <div *ngFor="let message of messageData; let i = index">
                                    <div
                                        *ngIf="((chatDialog.clear_chat_time && chatDialog.clear_chat_time[job_id]) < (message?.message_time) && (chatDialog.chat_dialog_id===message?.chat_dialog_id))">
                                        <a class="day">{{ i >0 ? ((messageData[i-1]?.message_time | messageGroupby) ===
                                            (message?.message_time | messageGroupby)? '': message?.message_time |
                                            messageGroupby ): message?.message_time | messageGroupby }} </a>
                                    </div>
                                    <div>
                                        <div *ngIf="((chatDialog.clear_chat_time && chatDialog.clear_chat_time[job_id]) < (message?.message_time) && (chatDialog.chat_dialog_id === message?.chat_dialog_id))"
                                            class='{{message?.sender_id == job_id ? "outgoing_msg" : "received_msg" }}'>
                                            <span class="deleteIcon"
                                                (click)="chatModal(DeleteSingleMsg,message?.message_id);myDrop1.close();"><img
                                                    src="../../../assets/images/delete.png" alt="delete icon"></span>
                                            <div class="{{getMessageType(message)}}"
                                                *ngIf="((chatDialog.clear_chat_time && chatDialog.clear_chat_time[job_id]) < (message?.message_time) && (chatDialog.chat_dialog_id===message?.chat_dialog_id))">
                                                <span class="time_date">{{message?.message_time | date:'hh:mm a'
                                                    }}</span>
                                                <p *ngIf="message?.message_type==1">
                                                    {{message?.message}}</p>
                                                <img *ngIf="message?.message_type==2" class="iconPdf"
                                                    src="https://media.honorvets.com/chatdocuments/{{message?.attachment_url}}"
                                                    (click)="open(message?.attachment_url)">
                                                <a *ngIf="message?.message_type==3"
                                                    href="https://media.honorvets.com/chatdocuments/{{message?.attachment_url}}"
                                                    target="_blank"><img
                                                        src="{{ (message?.attachment_url).substr((message?.attachment_url).lastIndexOf('.') + 1).toLowerCase() =='pdf' ? '../../../../assets/images/pdf.png' : '../../../../assets/images/google-docs.png' }}"
                                                        class="iconPdf"></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                            </div>

                            <!-- end -->
                            <div class="msgbottom" *ngIf="chat_dialog_id !== ''">
                                <a class="choose_file"><input id="fileUpload" type="file" id="uploadFile"
                                        class="upload-pic" #userPhoto (change)="onFileSelected($event)"><img
                                        src="assets/images/ic_attach.svg"></a>
                                <div class="type_msg">
                                    <form (ngSubmit)="sendMessage($event);">
                                        <div class="input_msg_write">
                                            <!------------->
                                            <input type="hidden" value="{{chat_dialog_id}}" id="chatDiologId">
                                            <input type="hidden" value="{{job_id}}" id="jobId">
                                            <input type="hidden" value="{{user_id}}" id="userId">

                                            <input type="hidden"
                                                value="{{un_read_message_count ? un_read_message_count : 0 }}"
                                                id="unReadMessageCount">
                                            <input type="hidden"
                                                value="{{(block_unblock && block_unblock==1) ? block_unblock : 0 }}"
                                                id="blockUnblockStatusSend">
                                            <input type="hidden"
                                                value="{{(other_block_unblock && other_block_unblock==1) ? other_block_unblock : 0 }}"
                                                id="myblock_status_send_message">
                                            <input type="hidden"
                                                value="{{(last_message_time) ? last_message_time : 0 }}"
                                                id="lastMessageTimeOthertext">
                                            <input type="hidden"
                                                value="{{(last_message_other) ? last_message_other : 0 }}"
                                                id="lastMessageOthertext">
                                            <input type="hidden"
                                                value="{{(other_user_unread_count) ? other_user_unread_count : 0 }}"
                                                id="otherUserUnreadCounttext">
                                            <!------------->
                                            <!-- <p *ngIf="message?.message_type==1">{{message.message}}</p> -->
                                            <div *ngIf="fileView" class="fileAttched">
                                                <div class="file-preview-container">
                                                    <div (click)="resetSelectedFile()" class="image-cross">
                                                        <span>X</span>
                                                    </div>
                                                    <img class="sendimgView" [src]="fileView"
                                                        *ngIf="fileView  && uploadType == 2">
                                                    <img class="sendimgView" src="../../../../assets/images/pdf.png"
                                                        *ngIf="fileView && uploadType == 3 && fileType == 'pdf'">
                                                    <img class="sendimgView"
                                                        src="../../../../assets/images/google-docs.png"
                                                        *ngIf="fileView && uploadType == 3 && (fileType == 'docx' || fileType == 'doc')">
                                                </div>
                                            </div>
                                            <textarea autocomplete="off" class="form-control" id="userMessage"
                                                name="userMessage" placeholder="{{ uploadFile ? '': 'Type a message'}}"
                                                [readonly]="fileView" *ngIf="!fileView"></textarea>
                                            <button class="msg_send_btn"><img src="assets/images/ic_send.svg"></button>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <figure class="noDataImage" *ngIf="chat_dialog_id ===''">
                        <img src="assets/images/illus_message.svg " alt="messages">
                    </figure>
                </div>

            </div>
        </div>
    </section>
</div>

<ng-template #block>
    <!-- Modal body -->
    <div class="modal-body">
        <h5 class="bold">Are you sure you want to {{ checkBlockStatus ?'Unblock':'Block' }} this user?</h5>

    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
        <div class="btnGroup">
            <form class="sellerForm adcd">
                <div class="row d-flex">
                    <!---------------------->

                    <input type="hidden" [(ngModel)]="checkBlockStatus" id="blockUnblockStatus"
                        [ngModelOptions]="{standalone: true}">
                    <!---------------------->
                    <div class="col-md-6"> <a href="javascript:void(0);" class="planbtn greyBtn"
                            (click)="modalRef9.hide()" data-dismiss="modal">Cancel</a>
                    </div>
                    <div class="col-md-6">
                        <button type="submit" class="planbtn fill" data-dismiss="modal"
                            (click)="blockUnblockUser()">Yes</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #Delete>
    <!-- Modal body -->
    <div class="modal-body">
        <h5 class="bold">Are you sure you want to delete this chat?</h5>

    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
        <div class="btnGroup">
            <form class="sellerForm adcd" (ngSubmit)="deleteUserChat($event)">
                <div class="row d-flex">
                    <div class="col-md-6"> <a href="javascript:void(0);" class="planbtn greyBtn"
                            (click)="modalRef9.hide()" data-dismiss="modal">Cancel</a>
                    </div>
                    <div class="col-md-6">
                        <button type="submit" class="planbtn fill" data-dismiss="modal"
                            (click)="modalRef9.hide()">Yes</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #DeleteSingleMsg>
    <!-- Modal body -->
    <div class="modal-body">
        <h5 class="bold">Are you sure you want to delete this ?</h5>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
        <div class="btnGroup">
            <form class="sellerForm adcd">
                <div class="row d-flex">
                    <div class="col-md-6"> <a href="javascript:void(0);" class="planbtn greyBtn"
                            (click)="modalRef9.hide()">Cancel</a>
                    </div>
                    <div class="col-md-6">
                        <button type="submit" class="planbtn fill" (click)="deleteUserChat1($event)">Yes</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>


<!-- End -->